/*=========================================================================================
  File Name: moduleTodoGetters.js
  Description: Todo List Module Getters
==========================================================================================*/
import _ from "lodash";
import CONSTANT from "@/utils/constant";

const formatProperties = properties => {
	const parsedProperties = properties ? JSON.parse(properties) : {};
	return {
		...parsedProperties,
		report: _.get(parsedProperties, "report") || null,
		is_done: _.get(parsedProperties, "is_done") || false,
		device_name: _.get(parsedProperties, "device_name") || "",
		priority: _.get(parsedProperties, "priority") || 0,
		review: _.get(parsedProperties, "review") || 0,
		start_date: _.get(parsedProperties, "start_date") || "",
		due_date: _.get(parsedProperties, "due_date") || 0,
		is_cancel: _.get(parsedProperties, "is_cancel") || false
	};
};

const formatTodo = todo => {
	const dataComments = Object.assign({}, todo.comments);
	if (dataComments && dataComments.data && dataComments.data.length) {
		dataComments.data = dataComments.data
			.map(comment => ({
				...comment,
				authorFullName: comment.author ? `${_.get(comment, "author.first_name") || ""}${_.get(comment, "author.last_name") ? " " + _.get(comment, "author.last_name") : ""}` : "",
				commentDatetime: comment.updated_at || ""
			}))
			.reverse();
	}

	return {
		...todo,
		dataId: todo.id,
		description: todo.description || "",
		dataName: todo.name || "",
		dataComments,
		employeeName: todo.employeeName || "",
		deviceName: todo.readableProperties.device_name || "",
		priority: todo.readableProperties.priority || 0,
		review: todo.readableProperties.review || 0,
		isDone: todo.readableProperties.is_done || false,
		deadline: todo.readableProperties.deadline || null,
		report: todo.readableProperties.report || null,
		isCancel: todo.readableProperties.is_cancel || false
	};
};

const formatRelation = relation => {
	let devicesName = [];
	let deviceId = null;
	if (relation && relation.length > 0) {
		relation.map(rel => {
			devicesName.push(rel.display);
			deviceId = rel.id;
		});
	}
	return {
		device_name: devicesName,
		device_id: deviceId
	};
};

export default {
	getParsedTodoList: state =>
		state.todoList.map(todoItem => ({
			...todoItem,
			employeeName: _.get(todoItem, "employees.0.name") || "",
			relationDevices: formatRelation(todoItem.relations || {}),
			readableProperties: formatProperties(todoItem.properties || {}),
			userOptionColor: (todoItem.user_option && todoItem.user_option.color) || CONSTANT.PICKER_COLORS[0].value
		})),
	getParsedTodo: () => todo =>
		formatTodo({
			...todo,
			readableProperties: formatProperties(todo.properties || {}),
			relationDevices: formatRelation(todo.relations || {})
		}),
	getTodo: (state, getters) => todoId => {
		const todo = getters.getParsedTodoList.find(todoItem => todoItem.id === todoId);
		if (todo) {
			return formatTodo(todo) || todo;
		}
		return null;
	},
	getTodoChildByParent: state => (parentTodo, filters) => {
		return state.todoListChild.filter(todoItem => {
			if (filters && filters.statuses.length > 0) {
				return todoItem.parent && todoItem.parent.id === parentTodo.id && _.includes(filters.statuses, JSON.parse(todoItem.status_object.key));
			} else {
				return todoItem.parent && todoItem.parent.id === parentTodo.id;
			}
		});
	}
};
